import { Radio } from "antd";
import classNames from "classnames";
import { useState } from "react";
import Label from "../../Label";

const Simple = ({
  errors,
  touched,
  label,
  icon,
  iconLabel,
  onChange,
  values = [],
  value,
  required,
  subLabel,
  size,
  row = false,
  ...rest
}) => {
  const [checkedValue, setCheckedValue] = useState(value);
  const onSelect = (e) => {
    setCheckedValue(e.target.value);
    onChange(e.target.value);
  };
  return (
    <div
      className={classNames("acoris__radio", size, {
        "acoris__radio--error": touched && errors,
      })}
    >
      <Label label={label} icon={iconLabel} required={required} />
      <div className="acoris__radio--field">
        <Radio.Group
          onChange={onSelect}
          value={checkedValue}
          defaultValue={value}
          className={classNames({ row })}
          {...rest}
        >
          {values.map(({ label, icon, value: _value }) => (
            <Radio
              key={`radio.${_value}`}
              value={_value}
              className={classNames({ checked: _value === checkedValue })}
            >
              <div className="acoris__radio--content">
                {icon && icon}
                <span className="acoris__radio--label">{label}</span>
              </div>
            </Radio>
          ))}
        </Radio.Group>
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

export default Simple;
